export default "__VITE_ASSET__7b33525b__"